var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormV2',{ref:"baseForm",attrs:{"model-class":_vm.Group,"id":_vm.id,"before-save-hook":_vm.beforeSaveHook,"navigate-on-save":_vm.navigateOnSave},on:{"created":_vm.onCreated}})}
var staticRenderFns = []

export { render, staticRenderFns }